import React from 'react';
import { ServiceOfPacket } from '../ServiceOfPacket';
export var BlockTickets = function (_a) {
    var item = _a.item;
    return (React.createElement("div", null,
        item.tickets.map(function (ticket, index) {
            return React.createElement(ServiceOfPacket, { item: item, ticket: ticket, index: index, key: ticket.numero, isCollaborator: false });
        }),
        item.collaboratorTickets.map(function (ticket, index) {
            return React.createElement(ServiceOfPacket, { item: item, ticket: ticket, index: index, key: ticket.numero, isCollaborator: true });
        })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockTickets.tsx
// module id = 1173
// module chunks = 0